/* src/components/project-status/project-status.component.scss */
:host {
  display: block;
}
.project-status {
  --vwui-badge--text: var(--vwui-color-light);
  white-space: nowrap;
}
.project-status--initial {
  --vwui-badge--bg: #008CBC;
}
.project-status--quickscan_saved {
  --vwui-badge--bg: #36B37A;
}
.project-status--mandating {
  --vwui-badge--bg: #FFAB01;
}
.project-status--closed {
  --vwui-badge--bg: var(--vwui-color-neutral-1);
}
.project-status--on_hold,
.project-status--mandating_failed {
  --vwui-badge--bg: var(--vwui-color-error);
}
.project-status--mandating_succeeded {
  --vwui-badge--bg: var(--vwui-color-primary);
}
.project-status--in_execution {
  --vwui-badge--bg: #0E4255;
}
/*# sourceMappingURL=project-status.component-P3EDRXZ6.css.map */
